export default {
	LINK_CLICK: 'linkClick',
	MENU_TOGGLE: 'menuToggle',
	HISTORY_BACK_REQUEST: 'historyBackRequest',
	AJAX_REQUEST_COMPLETE: 'onAjaxRequestComplete',
	AJAX_REQUEST_ERROR: 'onAjaxRequestError',
	COOKIES_WARNING_TOGGLE: 'cookiesWarningToggle'
};
